module.exports = __webpack_public_path__ + "img/location.5d9061f6.svg";